export default __webpack_public_path__ + "static/media/Aviso-orange.c976d196.svg";